import { render, staticRenderFns } from "./vendaexterna.vue?vue&type=template&id=a1c23f00&"
import script from "./vendaexterna.vue?vue&type=script&lang=js&"
export * from "./vendaexterna.vue?vue&type=script&lang=js&"
import style0 from "./vendaexterna.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports